export class ModalManager {
  static showConfirm({ 
    title = 'Confirm Action', 
    message = 'Are you sure?', 
    confirmText = 'Confirm', 
    cancelText = 'Cancel', 
    altText = '',
    variant = 'warning' 
  } = {}) {
    return new Promise((resolve) => {
      const overlay = document.getElementById('confirmModal');
      const titleEl = document.getElementById('confirmModalTitle');
      const messageEl = document.getElementById('confirmModalMessage');
      const confirmBtn = document.getElementById('confirmModalConfirm');
      const cancelBtn = document.getElementById('confirmModalCancel');
      const altBtn = document.getElementById('confirmModalAlt');

      if (!overlay || !titleEl || !messageEl || !confirmBtn || !cancelBtn) {
        console.warn('Confirm modal elements not found');
        resolve(false);
        return;
      }

      titleEl.textContent = title;
      messageEl.textContent = message;
      confirmBtn.textContent = confirmText;
      cancelBtn.textContent = cancelText;

      // Two-button callers resolve true/false as before; adding altText opts
      // into the three-way form, which resolves 'confirm' | 'alt' | 'cancel'.
      const threeWay = !!altText;
      if (altBtn) {
        altBtn.hidden = !threeWay;
        altBtn.textContent = altText || '';
      }
      overlay.setAttribute('data-variant', variant);

      const iconWrap = document.getElementById('confirmModalIconWrap');
      const icon = document.getElementById('confirmModalIcon');
      
      if (iconWrap && icon) {
        if (variant === 'destructive') {
          iconWrap.setAttribute('class', 'w-10 h-10 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0');
          icon.setAttribute('class', 'w-5 h-5 text-primary');
          icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>';
        } else {
          iconWrap.setAttribute('class', 'w-10 h-10 bg-accent2-50 rounded-xl flex items-center justify-center flex-shrink-0');
          icon.setAttribute('class', 'w-5 h-5 text-accent2-600');
          icon.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>';
        }
      }

      overlay.classList.remove('hidden', 'closing');

      function cleanup() {
        confirmBtn.removeEventListener('click', onConfirm);
        cancelBtn.removeEventListener('click', onCancel);
        if (altBtn) altBtn.removeEventListener('click', onAlt);
        overlay.removeEventListener('click', onOverlayClick);
      }

      function closeModal(result) {
        cleanup();
        overlay.classList.add('closing');
        setTimeout(() => {
          overlay.classList.add('hidden');
          overlay.classList.remove('closing');
          resolve(result);
        }, 150);
      }

      function onConfirm() { closeModal(threeWay ? 'confirm' : true); }
      function onAlt() { closeModal('alt'); }
      function onCancel() { closeModal(threeWay ? 'cancel' : false); }
      function onOverlayClick(e) {
        // Dismissing by clicking away is never one of the destructive answers.
        if (e.target === overlay) closeModal(threeWay ? 'cancel' : false);
      }

      confirmBtn.addEventListener('click', onConfirm);
      cancelBtn.addEventListener('click', onCancel);
      if (altBtn) altBtn.addEventListener('click', onAlt);
      overlay.addEventListener('click', onOverlayClick);
    });
  }
}
